/* eslint-disable react/jsx-props-no-spreading -- want to keep this automatically in sync with Typography */

// These Typography wrappers convey the underlying semantic HTML elements in
// order for accessibility support to be emphasized in JSX.

import React from 'react';
import {
  Typography,
  type TypographyKind,
  type TypographyProps,
} from '@saviynt/design-system';

/**
 * Simple DX wrapper for label Typography, that highlights the semantics.
 */
export function Label({
  children,
  ...rest
}: Omit<TypographyProps, 'kind'>): JSX.Element {
  return (
    <Typography kind='label' {...rest}>
      {children}
    </Typography>
  );
}

/**
 * Simple DX wrapper for h2 Typography, that highlights the semantics.
 */
export function H2({
  children,
  ...rest
}: Omit<TypographyProps, 'kind'>): JSX.Element {
  return (
    <Typography kind='h3' {...rest}>
      {children}
    </Typography>
  );
}

/**
 * Simple DX wrapper for h3 Typography, that highlights the semantics.

 */
export function H3({
  children,
  ...rest
}: Omit<TypographyProps, 'kind'>): JSX.Element {
  return (
    <Typography kind='h3' {...rest}>
      {children}
    </Typography>
  );
}

/**
 * Simple DX wrapper for p tag Typography, that highlights the semantics.
 *
 */
export function P({
  children,
  variant = 1,
  bold = false,
  ...rest
}: Omit<TypographyProps, 'kind'> & {
  variant?: number;
  bold?: boolean;
}): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const kind = `body${variant}${bold ? '-bold' : ''}` as TypographyKind;

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- passing dynamically-built kind value - TypeScript can't verify type safety at compile time
    <Typography kind={kind} {...rest}>
      {children}
    </Typography>
  );
}
